/**
 * @generated SignedSource<<6a1fea3ac823848744720d07824f30dd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type UpdateCustomFieldValueInput = {
  id?: string | null;
  entityId?: string | null;
  entityType?: string | null;
  key?: string | null;
  value?: string | null;
  csrfToken?: string | null;
  socketClientId?: string | null;
  clientMutationId?: string | null;
};
export type updateTicketCustomFieldValueMutation$variables = {
  input: UpdateCustomFieldValueInput;
};
export type updateTicketCustomFieldValueMutation$data = {
  readonly updateCustomFieldValue: {
    readonly customFieldValue: {
      readonly node: {
        readonly __typename: string;
        readonly id: string;
        readonly key: string;
        readonly type: string;
        readonly displayName: string;
        readonly value: string | null;
        readonly displayValue: string | null;
      } | null;
    } | null;
  } | null;
};
export type updateTicketCustomFieldValueMutation = {
  variables: updateTicketCustomFieldValueMutation$variables;
  response: updateTicketCustomFieldValueMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCustomFieldValuePayload",
    "kind": "LinkedField",
    "name": "updateCustomFieldValue",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CustomFieldValueV2TypeEdge",
        "kind": "LinkedField",
        "name": "customFieldValue",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "node",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "key",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "type",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayName",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "value",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "displayValue",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "updateTicketCustomFieldValueMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "updateTicketCustomFieldValueMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "3dffc125ce4b62ea018fe2c21f43ae27",
    "id": null,
    "metadata": {},
    "name": "updateTicketCustomFieldValueMutation",
    "operationKind": "mutation",
    "text": "mutation updateTicketCustomFieldValueMutation(\n  $input: UpdateCustomFieldValueInput!\n) {\n  updateCustomFieldValue(input: $input) {\n    customFieldValue {\n      node {\n        __typename\n        id\n        key\n        type\n        displayName\n        value\n        displayValue\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "da63bacaf21e31cc3511c043373ed020";

export default node;
